
export default function Services() {
  const services = [
    {
      icon: 'ri-government-line',
      title: 'Devlet İzinleri ve Yasal Süreçler',
      description: 'Sanayi sicilden kapasite raporuna tüm resmi işlemleriniz için uzman desteği',
      items: [
        'Kapasite Raporu Hazırlama',
        'Sanayi Sicil Belgesi',
        'Yerli Malı Belgesi',
        'ÇED Kapsam Dışı Görüşü',
        'İşyeri Açma ve Çalışma Ruhsatı'
      ],
      color: '#C17F59'
    },
    {
      icon: 'ri-ship-line',
      title: 'Ürün Belgelendirme ve İhracat',
      description: 'Ürünlerinizi dünya pazarlarına açan uluslararası sertifikasyonlar',
      items: [
        'CE İşareti (Avrupa)',
        'EAC Sertifikası (Avrasya)',
        'SABER Belgesi (Suudi Arabistan)',
        'RoHS Uygunluk Belgesi',
        'TSE Ürün Belgelendirme',
        'Gümrük ve İhracat Danışmanlığı'
      ],
      color: '#C17F59'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Yatırım ve Kurulum Danışmanlığı',
      description: 'Yeni yatırımlarınız için fizibilite, teşvik ve proje desteği',
      items: [
        'Detaylı Fizibilite Raporu',
        'Yatırım Teşvik Belgesi Danışmanlığı',
        'KOSGEB Proje Destekleri',
        'TÜBİTAK Ar-Ge Projeleri',
        'Fabrika Kurulum Danışmanlığı'
      ],
      color: '#C17F59'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Yönetim Sistemleri ve Standartlar',
      description: 'ISO standartları ve hizmet yeterlilik belgelendirme süreçleri',
      items: [
        'ISO 9001 Kalite Yönetim Sistemi',
        'ISO 14001 Çevre Yönetim Sistemi',
        'ISO 45001 İş Sağlığı ve Güvenliği',
        'ISO 22000 Gıda Güvenliği',
        'ISO 27001 Bilgi Güvenliği',
        'HYB (Hizmet Yeterlilik Belgesi)'
      ],
      color: '#C17F59'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Özel Yazılım Çözümleri',
      description: 'Süreçlerinizi dijitalleştiren özel yazılım sistemleri',
      items: [
        'Periyodik Muayene Takip Sistemi',
        'Kalibrasyon Laboratuvar Yönetimi',
        'Stok ve Üretim Takip Yazılımı',
        'Görev ve İş Takip Sistemi',
        'Özel ERP Entegrasyonları'
      ],
      color: '#C17F59'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Kalibrasyon Hizmetleri',
      description: 'TÜRKAK akrediteli laboratuvarımızda hassas ölçüm ve raporlama',
      items: [
        'TÜRKAK Akrediteli Laboratuvar',
        'Kütle Kalibrasyonu',
        'Sıcaklık Kalibrasyonu',
        'Basınç Kalibrasyonu',
        'Boyut Kalibrasyonu',
        'Periyodik Kalibrasyon Takibi'
      ],
      color: '#C17F59'
    }
  ];

  return (
    <section id="hizmetler" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232D3436' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-[#2D3436] mb-4 tracking-tight">
            Kapsamlı Endüstriyel Çözümler
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Yatırım fikrinden ihracat aşamasına, mevzuat danışmanlığından yazılım çözümlerine kadar 360° hizmet
          </p>
        </div>

        {/* Services Grid - 3 columns for better layout with 6 cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-8 shadow-[0_2px_20px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_30px_rgba(193,127,89,0.15)] transition-all duration-300 border border-gray-100 hover:border-[#C17F59]/30 hover:-translate-y-2 cursor-pointer relative overflow-hidden"
            >
              {/* Subtle gradient overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#C17F59]/0 to-[#C17F59]/0 group-hover:from-[#C17F59]/5 group-hover:to-transparent transition-all duration-300 rounded-xl"></div>
              
              <div className="relative">
                {/* Icon */}
                <div className="mb-6">
                  <div className="w-14 h-14 rounded-lg bg-[#C17F59]/10 flex items-center justify-center group-hover:bg-[#C17F59] transition-all duration-300">
                    <i className={`${service.icon} text-3xl text-[#C17F59] group-hover:text-white transition-all duration-300`}></i>
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-[#2D3436] mb-3 leading-tight">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Items List */}
                <ul className="space-y-2.5">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-sm text-gray-700">
                      <i className="ri-check-line text-[#C17F59] mt-0.5 flex-shrink-0 font-semibold"></i>
                      <span className="leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            İşletmeniz için en uygun çözümü birlikte belirleyelim
          </p>
          <a
            href="#iletisim"
            className="inline-flex items-center bg-[#C17F59] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#A66B47] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <span>Ücretsiz Danışmanlık Alın</span>
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
